import { InputTextDesignTokens } from '@primeuix/themes/types/inputtext';

export const inputTextPreset: InputTextDesignTokens = {
  colorScheme: {
    light: {
      root: {
        focusBorderColor: 'transparent',
        hoverBorderColor: 'transparent',
        borderColor: 'transparent',
        disabledBackground: 'transparent'
      }
    }
  }
}
